"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEVNET_LP_TOKENS = exports.DEVNET_SPL_TOKENS = void 0;
const sol_1 = require("./sol");
exports.DEVNET_SPL_TOKENS = {
    *[Symbol.iterator]() {
        yield* Object.values(this);
    },
    WSOL: Object.assign({}, sol_1.WSOL),
};
exports.DEVNET_LP_TOKENS = {
    *[Symbol.iterator]() {
        yield* Object.values(this);
    },
};
//# sourceMappingURL=devnet.js.map